import { defineStore } from 'pinia'
import { SnackbarMessagePayload } from '@/store/models/snackbar'

export const useSnackbarStore = defineStore({
  id: 'snackbar',
  persist: false,
  state: () => ({
    showSnackbar: false,
    // color: success - "success", error - "error",
    color: 'success',
    timeout: 3000,
    // icon: success - "mdi-checkbox-marked-circle", error - "mdi-alert-circle",
    icon: 'mdi-checkbox-marked-circle',
    title: 'Success',
    text: 'Success',
    lines: [] as string[],
    location: 'top',
    actionLabel: '',
    onAction: null as (() => void) | null,
    openedAt: 0,
  }),

  actions: {
    showMessage (payload: SnackbarMessagePayload) {
      this.color = payload.color
      // Error - 600 seconds, other - 3 seconds
      this.timeout = payload.timeout !== undefined
        ? payload.timeout
        : (payload.color === 'error' ? 600000 : 3000)
      this.icon = payload.icon
      this.title = payload.title
      this.text = payload.text || ''
      this.lines = payload.lines || []
      this.location = payload.location || 'top'
      this.actionLabel = payload.actionLabel || ''
      this.onAction = payload.onAction || null

      this.openedAt = Date.now()
      this.showSnackbar = true
      return this.openedAt
    },

    closeMessage () {
      this.showSnackbar = false
    },

    closeMessageIfOpenedAt (openedAt: number) {
      if (this.openedAt === openedAt) this.closeMessage()
    },
  },
})

// Define the type of the store
export type SnackbarStore = ReturnType<typeof useSnackbarStore>
